import Dialog from "@mui/material/Dialog";
import React from "react";
import { FaTimes } from "react-icons/fa";
import { toast } from "sonner";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";

const LogoutConfirmationModal = ({ onClose, isOpen }) => {
  const navigate = useNavigate();

  const { logout, setUserRole } = useAuth();

  const onConfirm = () => {
    logout();
    localStorage.clear();
    setUserRole("public");
    navigate("/");
    onClose();
    toast.success("Logged out successfully!");
  };

  const onCancel = () => {
    onClose();
  };
  
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="relative bg-white p-8 rounded-lg shadow-xl  text-center">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-red-100 hover:text-gray-700 transition-colors"
          aria-label="Close confirmation dialog"
        >
          <FaTimes size={18} />
        </button>

        <h2 className="text-xl font-bold mb-4 text-gray-800">Confirm Logout</h2>
        <p className="text-gray-700 mb-6">Are you sure you want to log out?</p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={onCancel}
            className="px-6 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
          >
            Yes, Logout
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default LogoutConfirmationModal;
